const dummy = [{
  speech: "皆さん。今回は重要な選挙です。新しい党が次々できました。何党なのか名前もわからないですね。私は名前が変わっただけで、結局、中身は何も変わっていないと思います。１９９０年代、新党ブームがありました。この新党ブームが生み出したものは何だったのでしょうか。それは残念ながら政治の混乱と経済の低迷でした。新党というイメージにだまされてはいけません。",
  choices: ["今回は重要な選挙です。新しい党が次々できました。", "何党なのか名前もわからないですね。私は名前が変わっただけで、結局、中身は何も変わっていないと思います。", "１９９０年代、新党ブームがありました。この新党ブームが生み出したものは何だったのでしょうか。それは残念ながら政治の混乱と経済の低迷でした。"],
  taiks: [
    {
      boy: "選挙だね。与党の議員も一生懸命だ。",
      girl: "でも、少しおかしくない？　ファクト君、ファクトチェックしてみてよ。"
    },
    {
      boy: "どこを調べる？",
      girl: "それは政治家の意見だから、ファクトチェックの対象じゃないよ。"
    },
    {
      boy: "どうやって調べる？",
      girl: ""
    },
    {
      boy: "この発言は正しいね？",
      girl: "でも、他におかしい部分があるんじゃない？"
    },
    {
      boy: "政治は混乱していたね。じゃあ、この発言は正しいんだ？",
      girl: "もう少し、よく見てみよう。"
    },
    {
      boy: "株価が一気に下がっている",
      girl: "よく見てごらん。"
    },
    {
      boy: "あれ？　新党ブームが起きて、株価が下がっているのは細川政権が誕生する前だ。",
      girl: "そうなの。新党ブームの前から経済は低迷した、ということだね。"
    },

  ]
}];

module.exports = dummy;


// WEBPACK FOOTER //
// ./src/assets/dummy-data.js